/**
 * Authentication utility functions
 * Simple helper functions for authentication checks
 */

/**
 * Check if user is authenticated
 * @param {Object} user - User object from Redux store
 * @returns {boolean} - True if user is authenticated
 */
export const isAuthenticated = (user) => {
  return !!(user && (user.id || user.email || user.isAuthenticated));
};

/**
 * Check if user has specific role or permission
 * @param {Object} user - User object from Redux store
 * @param {string} role - Role to check for
 * @returns {boolean} - True if user has the role
 */
export const hasRole = (user, role) => {
  return user && user.role === role;
};

/**
 * Check if user is super admin
 * @param {Object} user - User object from Redux store
 * @returns {boolean} - True if user is super admin
 */
export const isSuperAdmin = (user) => {
  return user && (user.role === 'super_admin' || user.isSuperAdmin);
};

/**
 * Get user display name
 * @param {Object} user - User object from Redux store
 * @returns {string} - User display name or email
 */
export const getUserDisplayName = (user) => {
  if (!user) return '';
  
  if (user.first_name && user.last_name) {
    return `${user.first_name} ${user.last_name}`;
  }
  
  if (user.name) {
    return user.name;
  }
  
  return user.email || 'User';
};

/**
 * Logout user and clear authentication
 * @param {Function} dispatch - Redux dispatch function
 */
export const logoutUser = (dispatch) => {
  try {
    // Clear token from localStorage
    localStorage.removeItem("@getGeek/token");
    
    // Dispatch logout action
    dispatch({ type: 'auth/logout' });
    
    console.log("User logged out successfully");
  } catch (error) {
    console.error("Error during logout:", error);
  }
};
